import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, ViewChild } from '@angular/core';
import { VALUE_ENTER, VALUE_ESCAPE } from '@wizeoo/akm-core-lib';
import { WizBasePopUp, WizEvent, WizNumericInput } from '@wizeoo/akm-component-lib';

import { StyleEngine } from '../../../manager/workingdata/style.engine';
import { ColorPickerPop } from '../../colorpicker/color-picker.pop';
import { IWidget } from '../../../manager/widgets/i-widget';
import { WIDGET_KIND } from '../../../model/enums';
import { ViewData } from '../../../model/view.data';

export interface WidgetDisplaySettings {
  title: string;
  rowHeight: number;
  headerHeight: number;
  fontColor: string;
  iconColor: string;
  backgroundColor: string;
  hideBorders: boolean;
  radius: number;
  borderColor: string;
  widgetBackgroundColor: string;

  fontColorH: string;
  backgroundColorH: string;
  widget: IWidget;
  // wco: WidgetConfigurationObj; // la conf du widget pour passage des confs par défaut (color & back des headers)
}

/**
 * Pop de sélection du périmètre de données du widget (Vision, vision step, step perimeter)
 */
@Component({
  templateUrl: './widget-display-settings.pop.html',
  styleUrls: ['./widget-display-settings.pop.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetDisplaySettingsPop extends WizBasePopUp {
  
  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
 
    if (event.key === VALUE_ENTER) {
      event.stopImmediatePropagation();
      event.preventDefault();
      this.onSave();
    }
    if (event.key === VALUE_ESCAPE) {
      event.stopImmediatePropagation();
      event.preventDefault();
      this.hide();
    }
  }  
  
  @ViewChild('ni', { read: WizNumericInput, static: true }) ni: WizNumericInput;


  
  private get _settings(): WidgetDisplaySettings {
    return this.datas as WidgetDisplaySettings;
  }

  public static baseHeight: number = 500; // hauteur statique pour prise externe sur ouverture
  public static baseWidth: number = 350; // largeur, statique pour prise externe sur ouverture

  get widgetTitle(): string {
    return this._settings?.title;
  }

  get rowHeight(): number {
    return this._settings?.rowHeight || ViewData.defaultRowHeight;
  }

  get headHeight(): number {
    return this._settings?.headerHeight || ViewData.defaultHeaderHeight;
  }

  get fontColor(): string {
    return this._settings?.fontColor || StyleEngine.STYLE_DEFAULT_FONT_COLOR;
  }

  get backgroundColor(): string {
    return this._settings?.backgroundColor || StyleEngine.STYLE_DEFAULT_BACKGROUND_COLOR;
  }

  get iconColor(): string {
    return this._settings?.iconColor || StyleEngine.STYLE_DEFAULT_ICON_COLOR;
  }

  get fontColorH(): string {
    return this._settings?.fontColorH || StyleEngine.STYLE_DEFAULT_FONT_COLOR;
  }

  get backgroundColorH(): string {
    return this._settings?.backgroundColorH || StyleEngine.STYLE_DEFAULT_BACKGROUND_COLOR;
  }

  get areSettingsValid(): boolean {
    return this._settings?.title?.length > 0;
  }

  constructor(private _changeDetectorRef: ChangeDetectorRef) {
    super();
  }

  public showColorPicker(pEvent: Event, pProperty: string): void {
    ColorPickerPop.show(pEvent.target as HTMLElement, pEvent.target, this._settings[pProperty], (_, pColor) => {
      this.setColorValue(pProperty, pColor);
      this._changeDetectorRef.markForCheck();
    });
  }

  public setColorValue(pProperty: string, pValue: string = null): void {
    this.datas = {
      ...this.datas,
      [pProperty]: pValue,
    };
  }

  onChangeTitle(title: string): void {
    this.datas = {
      ...this.datas,
      title,
    };
  }

  onChangeRowHeight(rowHeight: number): void {
      this.datas = {
      ...this.datas,
      rowHeight,
    };
  }

  onChangeHeadHeight(headerHeight: number): void {
      this.datas = {
      ...this.datas,
      headerHeight,
    };
  }

  /** sur save, alimentation de l'objet de configuration */
  public onSave(): void {
    
    if(this._settings) {
      this._settings.radius = this.ni?.wizNumber;
    }
    
    
    if (this.callback && this._settings?.title?.length > 0) {
      this.callback(this._settings);
    }
    this.hide();
  }

  get hideBorders(): boolean {
    let result: boolean = false;
    if(!!this._settings?.hideBorders) {
      result = true;
    }
    return result;
  }
  public setHideBorders(e: WizEvent): void {
    this._settings.hideBorders = e.value;
  }

  get radius(): number {
    let result: number = 0;
    if(!!this._settings?.radius) {
      result = this._settings.radius;
    }
    // console.log('getRadius', result);
    return result;
  }
  public setRadius(e: WizEvent): void {
    // console.log('setRadius', e);
    this._settings.radius = e.value;
  }


  get widgetBackgroundColor(): string {
    return this._settings?.widgetBackgroundColor || StyleEngine.STYLE_DEFAULT_WIDGET_BACKGROUND_COLOR;
  }

  get widgetBorderColor(): string {
    return this._settings?.borderColor || StyleEngine.STYLE_DEFAULT_WIDGET_BACKGROUND_COLOR;
  }


  public get hasColumns():boolean {
    return this._settings?.widget.widgetKind === WIDGET_KIND.GRID ||
    this._settings?.widget.widgetKind === WIDGET_KIND.PIVOT ||
    this._settings?.widget.widgetKind === WIDGET_KIND.FORM ||
    this._settings?.widget.widgetKind === WIDGET_KIND.FD_GRID;

  }

}
